<template>
  <div class="new-comments" v-if="newsNum">
    <div class="new-comments-container" @click="showCommentsDetail">
      <svg-icon icon-name="icon-notice" :size="20" class="mx-10"></svg-icon>
      <span>{{ $t("newComments.title", { num: newsNum,role:isKpmgUser?$t('newComments.client'):$t('newComments.kpmg')}) }}</span>
    </div>
    <div v-if="commentsDetailVisible">
      <el-dialog
        visible
        width="55%"
        :title="$t('newComments.dlgTitle',{role:isKpmgUser?$t('newComments.client'):$t('newComments.kpmg')})"
        :footer="null"
        @close="onCancel"
      >
        <div class="comments-all">
          <div v-for="item in newCommentList" :key="item.type" class="border-normal comment-row mb-15">
            <div class="left flex item-center">
              <el-avatar size="medium" :src="circleUrl" class="mr-20 flex-0"></el-avatar>
              <div>
                <div class="messageBy">
                  {{ item.commentUser}}
                  {{ item.sendUserName }}
                  <span class="create-date" v-if="item.commentTime">【{{ item.commentTime | formatDateTime }}】</span>
                  <span class="create-date" v-if="item.createDate">【{{ item.createDate | formatDateTime }}】</span>
                </div>
                <div class="comment mt-10">
                  {{ item.comment }}
                  {{ item.messageContent }}
                </div>
              </div>
            </div>
            <div class="right">
              <template v-if="messageType === '1' || messageType === '2'">
                <div>
                  <span class="label">{{ $t('serialNo') }}:</span>
                  <span>{{ item.serialNo }}</span>
                </div>
                <div class="mt-10">
                  <span class="label">{{ $t('TABLE_HEADER_entityList') }}:</span>
                  <span>{{ item.entityName }}</span>
                </div>
                <div class="mt-10">
                  <span class="label">{{ $t('TABLE_HEADER_topicName') }}:</span>
                  <span>{{ item.topicName }}</span>
                </div>
              </template>
              <template v-if="messageType === '5'">
                <div>
                  <span class="label">{{ $t('TABLE_HEAD_EntityList') }}:</span>
                  <span>{{ item.entityName }}</span>
                </div>
                <div class="mt-10">
                  <span class="label">{{ $t('TABLE_HEAD_Category') }}:</span>
                  <span>{{ renderCategory(item.category) }}</span>
                </div>
              </template>
              <template v-if="messageType === '3'">
                <div>
                  <span class="label">{{ $t('TABLE_HEAD_EntityList2') }}:</span>
                  <span>{{ item.entityName }}</span>
                </div>
                <div class="mt-10">
                  <span class="label">{{ $t('TABLE_HEAD_Category') }}:</span>
                  <span>{{ item.category }}</span>
                </div>
              </template>
              <template v-if="messageType === '4'">
                <div>
                  <span class="label">{{ $t('TABLE_HEAD_Category') }}:</span>
                </div>
                <div class="mt-10">
                  <span>{{ item.category }}</span>
                </div>
              </template>
              <template v-if="messageType === '6'">
                <div class="label">
                  {{ $t('admin.invoiceNumber') }}:
                </div>
                <div class="mt-10">
                  {{ item.invoiceNumber }}
                </div>
              </template>
              <template v-if="messageType === '7'">
                <div class="label">
                  {{ $t('admin.entityId') }}
                </div>
                <div class="mt-10">
                  {{ item.entityId }}
                </div>
              </template>
              <template v-if="messageType === '9'|| messageType === '8'">
                <div>
                  <span class="label">{{ $t('TABLE_HEADER_entityList') }}:</span>
                  <span>{{ getEntityName(item) }}</span>
                </div>
                <div class="mt-10">
                  <span class="label">{{ $t('TABLE_HEADER_matter') }}:</span>
                  <span>{{ item.matter }}</span>
                </div>
              </template>
              <template v-if="messageType === '11'">
                <div>
                  <span class="label">{{ $t('confirmation.details_list.table.unique_id_nocss') }}:</span>
                  <span>{{ item.uniqueId }}</span>
                </div>
                <div class="mt-10">
                  <span class="label">{{ $t('confirmation.details_list.table.entity_name') }}:</span>
                  <span>{{ item.confirmationEntityName }}</span>
                </div>
                <div class="mt-10">
                  <span class="label">{{ $t('confirmation.details_list.table.addressee_entity_name') }}:</span>
                  <span>{{ item.addrEntityName }}</span>
                </div>
              </template>
              <template v-if="messageType === '12'">
                <div class="font-bolder">
                  {{ $t('TABLE_HEADER_ENTITIES') }}:
                </div>
                <div class="mt-10">
                  <span>{{ item.entityName }}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import API from "@/api";
import SvgIcon from "@/components/svgIcon/index";

const categoryOptions = [
  {realValue: 'Confirmations', value: 'exchangeCategory._1'},
  {realValue: 'Reports', value: 'exchangeCategory._2'},
  {realValue: 'Templates', value: 'exchangeCategory._3'},
  {realValue: 'Analysis', value: 'exchangeCategory._4'},
  {realValue: 'TOD sample', value: 'exchangeCategory._5'}
]

export default {
  name: "NewComments",
  components: { SvgIcon },
  props: {
    messageType: {
      type: String,
      default: "",
    },
    siteId: {
      type: String,
      default: "",
    },
  },
  computed:{
    ...mapGetters('common', {
        getUser: 'getUser',
    }),
    isKpmgUser() {
        return this.getUser.userType === '1'
    },
  },
  watch:{
    messageType:{
      immediate:true,
      handler(value){
        if(value){
          this.queryTodayCount()
        }else{
          this.resetItems();
        }
      }
    }
  },
  data() {
    return {
      newsNum: null,
      newCommentList: [],
      circleUrl: require("@/assets/img/messageboard1.png"),
      commentsDetailVisible: false,
    };
  },
  methods: {
    renderCategory(category){
      const findCategory = categoryOptions.find((vv) => vv.realValue === category)
      return !!findCategory ? this.$t(findCategory.value) : category
    },
    resetItems(){
      this.newsNum = null;
      this.newCommentList = [];
    },
    showCommentsDetail() {
      this.queryTodayCommentInfos();
      this.commentsDetailVisible = true;
    },
    onCancel() {
      this.commentsDetailVisible = false;
    },
    getEntityName(item){
      if(item.entityList){
        return item.entityList.map(item=>item.entityName).join(',')
      }
      return ''
    },
    /**
     * 评论消息类型
     */
    // PBC_INTERIM("1", "PBC中期"),
    // PBC_FINAL("2", "PBC年末"),
    // GR_DELIVERABLES_COLLECTION("3", "集团审计-报告收集"),
    // GR_Shared_Documents("4", "集团审计-共享文件"),
    // JW_FILES_SHARING("5", "携手共享-客户文件交换"),
    // CA_INVOICE("6", "客户项目管理-账单"),
    // CA_VAT("7", "客户项目管理-增值税信息"),
    // ML_INTERIM("8", "事项日志-中期"),
    // ML_FINAL("9", "事项日志-年末");
    //11 审计函证 前端自定义
    //12 法定审计报告 前端自定义
    async queryTodayCount() {
      if (!this.messageType) return;
      let _api = "";
      let menuId = "";
      switch (this.messageType) {
        case "1":
        _api = API.pbc.queryTodayCount;
        menuId = "14"
          break;
        case "2":
        _api = API.pbc.queryTodayCount;
        menuId = "14"
          break;
        case "3":
        _api = API.pbc.queryTodayCount;
        menuId = "24"
          break;
        case "4":
        _api = API.pbc.queryTodayCount;
        menuId = "24"
          break;
        case "5":
        _api = API.pbc.queryTodayCount;
        menuId = "20"
          break;
        case "6":
        _api = API.clientAdmin.queryTodayCount;
          break;
        case "7":
        _api = API.clientAdmin.queryTodayCount;
          break;
        case "8":
        _api = API.matterLogs.queryTodayCount;
          break;
        case "9":
          _api = API.matterLogs.queryTodayCount;
          break;
        case "11":
        _api = API.confirmation.queryTodayCount;
        break;
        case "12":
        _api = API.status.queryTodayCount;
        break;
      }

      if(!_api) return;

      const {code,data} = await _api({
        messageType: this.messageType,
        siteId: this.siteId,
        menuId: menuId ? menuId:null
      })

      if(code === '1'){
        this.newsNum = data;
      }

    },
    async queryTodayCommentInfos() {
      if (!this.messageType) return;
      let _api = "";
      let menuId = "";
      switch (this.messageType) {
        case "1":
        _api = API.pbc.queryTodayCommentInfos;
        menuId = "14"
          break;
        case "2":
        _api = API.pbc.queryTodayCommentInfos;
        menuId = "14"
          break;
        case "3":
        _api = API.exchange.queryTodayCommentInfos;
        menuId = "24"
          break;
        case "4":
        _api = API.exchange.queryTodayCommentInfos;
        menuId = "24"
          break;
        case "5":
        _api = API.exchange.queryTodayCommentInfos;
        menuId = "20"
          break;
        case "6":
        _api = API.clientAdmin.queryInvoiceTodayCommentInfos;
          break;
        case "7":
        _api = API.clientAdmin.queryVatTodayCommentInfos;
          break;
        case "8":
        _api = API.matterLogs.queryTodayCommentInfos;
          break;
        case "9":
          _api = API.matterLogs.queryTodayCommentInfos;
          break;
        case "11":
        _api = API.confirmation.queryTodayCommentInfos;
        break;
        case "12":
        _api = API.status.queryTodayCommentInfos;
        break;
      }

      if(!_api) return;

      const {code,data} = await _api({
        messageType: this.messageType,
        siteId: this.siteId,
        menuId: menuId ? menuId:null
      })

      if(code === '1'){
        this.newCommentList = data? data:[];
      }

      console.log(data);

    },
  },
};
</script>

<style scoped>
.new-comments-container {
  border: 1px solid rgb(254, 128, 193);
  color: rgb(254, 128, 193);
  background: rgb(255, 243, 249);
  margin-bottom: 10px;
  padding: 5px 0;
  font-weight: bolder;
  border-radius: 5px;
  cursor: pointer;
}
.comments-all{
  max-height: 420px;
  overflow: auto;
}
.create-date {
  font-size: 12px;
  color: rgb(185, 185, 193);
  display: inline-block;
}
.comment-row {
  padding: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.comment {
  font-weight: bolder;
}
.left{
  max-width: 60%;
}
.flex-0{
  flex-shrink: 0;
}
.right {
  text-align: right;
}
.label{
  font-weight: bolder;
  margin-right: 10px;
}
.font-bolder{
  font-weight: bolder;
}
.messageBy {
  font-size: 16px;
}
</style>
